/**
 * 📦 受発注 Hub (v3.3 IA 刷新で新設)
 *
 * 統合対象 (旧 営業・取引から分離):
 *   - sales.quotes (見積)
 *   - sales.invoices (請求)
 *   - sales.purchase-orders (発注)
 *   - sales.deliveries (発送)
 *   - sales.sold-devices (稼働機器)
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { QuotesListPage } from '@/pages/quotes/QuotesListPage';
import { InvoicesListPage } from '@/pages/invoices/InvoicesListPage';
import { PurchaseOrdersListPage } from '@/pages/purchase-orders/PurchaseOrdersListPage';
import { DeliveriesListPage } from '@/pages/deliveries/DeliveriesListPage';
import { SoldDevicesListPage } from '@/pages/sold-devices/SoldDevicesListPage';

const TABS: TabSpec[] = [
  { tabKey: 'quotes',   label: '見積',     featureId: 'sales.quotes',          render: () => <QuotesListPage /> },
  { tabKey: 'invoices', label: '請求',     featureId: 'sales.invoices',        render: () => <InvoicesListPage /> },
  { tabKey: 'po',       label: '発注',     featureId: 'sales.purchase-orders', render: () => <PurchaseOrdersListPage /> },
  { tabKey: 'shipping', label: '発送',     featureId: 'sales.deliveries',      render: () => <DeliveriesListPage /> },
  { tabKey: 'devices',  label: '稼働機器', featureId: 'sales.sold-devices',    render: () => <SoldDevicesListPage /> },
];

export function OrdersHubPage() {
  return <HubTabs tabs={TABS} defaultTab="quotes" />;
}
